var map = {
	"./HadasaAndSagiv-0523.webp": 8919,
	"./NatalieAsaf-0475.webp": 9391,
	"./ShahafAndMoran-1231.webp": 1682,
	"./ShayAndOri-0654.webp": 7069,
	"./batch_037A3542.webp": 5127,
	"./batch_037A6502.webp": 4642,
	"./batch_037A8928.webp": 3716,
	"./batch_IMG-0135.webp": 4253,
	"./batch_IMG-0653-AI.webp": 1597,
	"./batch_IMG-0834-AI.webp": 8742,
	"./batch_IMG-1754.webp": 7719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9813;